import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ModuleName } from 'src/app/middleware/common/Enum/common.enum';
import { AddEmailActionComponent } from 'src/app/middleware/common/addEmailAction/addEmailAction.component';
import { WelcomeEmailComponent } from 'src/app/middleware/common/welcomeEmail/welcome-email.component';
import { WelcomeEmailResult } from 'src/app/middleware/common/welcomeEmail/welcome-email.model';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss']
})
export class EmailComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any=[];
  myOfficeID: any;

  @Input() mainModulename: string;
  /** Display name of the record this tab belongs to, sent as coreName. */
  @Input() recordName: string;
 
  getTagListResponseHolder: any;
  All3CEmailList:any=[]=[];
  /** Number of emails, for the record tab badge. */
  @Output() countChange = new EventEmitter<number>();
  All3CBroadCastList:any=[]=[];
  showEmail:boolean=true;
  showBroadCast:boolean=false;
  title:string="View Broadcasting";
  @Input() coreDetail:any=[]=[];

  /* ---- list view helpers (segmented switch + search) ---------------------- */

  emailSearch: string = '';

  // Emails | Broadcasts switch — same paths as the old slide toggle
  showList(kind: 'email' | 'broadcast') {
    if (kind === 'broadcast' && !this.showBroadCast) { this.changeToggle({ checked: true }); }
    if (kind === 'email' && !this.showEmail) { this.changeToggle({ checked: false }); }
  }

  private matchesSearch(...fields: any[]): boolean {
    const q = (this.emailSearch || '').trim().toLowerCase();
    if (!q) return true;
    return fields.filter(f => f != null).join(' ').toLowerCase().indexOf(q) !== -1;
  }

  get filteredEmails(): any[] {
    return (this.All3CEmailList || []).filter((e: any) => this.matchesSearch(e.subject, e.toRecipients));
  }

  get filteredBroadcasts(): any[] {
    return (this.All3CBroadCastList || []).filter((b: any) => this.matchesSearch(b.subject));
  }

  /* ---- list row helpers ----------------------------------------------------- */

  // Plain-text snippet of an HTML body for the row preview; cached per item.
  private previewCache = new WeakMap<any, { src: string; text: string }>();

  messagePreview(item: any, field: string = 'body'): string {
    const src = (item && item[field]) || '';
    const hit = this.previewCache.get(item);
    if (hit && hit.src === src) return hit.text;
    const div = document.createElement('div');
    div.innerHTML = src.replace(/<(style|script)[\s\S]*?<\/\1>/gi, ' ');
    const text = (div.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 180);
    this.previewCache.set(item, { src, text });
    return text;
  }

  // Avatar initials + tone from the first recipient ("matt@flowtrics.com" -> "MA")
  recipientInitials(to: string): string {
    const first = ((to || '').split(/[;,]/)[0] || '').trim();
    const local = first.split('@')[0].replace(/[^a-zA-Z0-9. _-]/g, '');
    const parts = local.split(/[._ -]+/).filter(Boolean);
    const letters = parts.length > 1 ? parts[0][0] + parts[1][0] : local.slice(0, 2);
    return (letters || '?').toUpperCase();
  }

  private readonly avatarTones = ['blue', 'violet', 'green', 'amber', 'teal', 'rose'];

  recipientTone(to: string): string {
    let h = 0;
    const s = ((to || '').split(/[;,]/)[0] || '').trim().toLowerCase();
    for (let i = 0; i < s.length; i++) { h = (h * 31 + s.charCodeAt(i)) >>> 0; }
    return this.avatarTones[h % this.avatarTones.length];
  }

  // Grouped lists for the template, rebuilt only when the list or the search
  // changes (fresh arrays every change-detection pass would re-render the rows
  // and collapse whatever the user had opened).
  private groupCache: { [kind: string]: { src: any; q: string; day: number; groups: any[] } } = {};

  private cachedGroups(kind: string, src: any[], filtered: () => any[]): { label: string; items: any[] }[] {
    const q = this.emailSearch || '';
    const day = new Date().getDate();
    const c = this.groupCache[kind];
    if (c && c.src === src && c.q === q && c.day === day) return c.groups;
    const groups = this.groupByDate(filtered());
    this.groupCache[kind] = { src, q, day, groups };
    return groups;
  }

  get emailGroups() {
    return this.cachedGroups('email', this.All3CEmailList, () => this.filteredEmails);
  }

  get broadcastGroups() {
    return this.cachedGroups('broadcast', this.All3CBroadCastList, () => this.filteredBroadcasts);
  }

  trackRow(index: number, item: any) {
    return item?.id ?? item?.activityEmailID ?? index;
  }

  // Rows grouped under Today / Yesterday / Earlier this week / Earlier
  groupByDate(list: any[]): { label: string; items: any[] }[] {
    const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const today = startOfDay(new Date());
    const day = 24 * 60 * 60 * 1000;
    const order = ['Today', 'Yesterday', 'Earlier this week', 'Earlier'];
    const groups: { [label: string]: any[] } = {};
    (list || []).forEach((item: any) => {
      const t = item?.sentDate ? startOfDay(new Date(item.sentDate + 'Z')) : 0;
      const label = !t ? 'Earlier'
        : t >= today ? 'Today'
        : t >= today - day ? 'Yesterday'
        : t >= today - 6 * day ? 'Earlier this week'
        : 'Earlier';
      (groups[label] = groups[label] || []).push(item);
    });
    return order.filter(l => groups[l]).map(l => ({ label: l, items: groups[l] }));
  }

  constructor(private dialog: MatDialog,private taskService: SettingService,
    private statusConst: StatusConstant, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private loaderService: LoaderService,
    private toastr: ToastrService,) {
      const encryptedtoken = sessionStorage.getItem('userToken');
      this.databaseId = sessionStorage.getItem('databaseId')?? '';
       this.organizationId = sessionStorage.getItem('organizationID')?? '';
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach((oe:any) => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      }); 
   }

  ngOnInit(): void {
    this.getActivityEMails3C();
  }

  // Summary
  // Open the Send Template dialog. The dialog is presentational -- it loads the
  // contact list, collects the recipients and posts the send itself, then
  // hands back what it sent so this tab can refresh.
  openWelcomeEmail() {
    const dialogRef = this.dialog.open(WelcomeEmailComponent, {
      width: '65vw',
      maxWidth: '96vw',
      autoFocus: false,
      panelClass: 'welcome-email-dialog',
      data: {
        moduleName: this.mainModulename,
        // Context for Contact/GetCoreSelectedContact, which returns the
        // contacts attached to this core. Pass `contacts: [...]` here instead
        // to hand the dialog a ready-made list and skip the request.
        databaseID: this.databaseId,
        organizationID: this.organizationId,
        userID: this.currentUser ? this.currentUser.UID : null,
        coreID: sessionStorage.getItem('transactionID'),
        subjectName: this.recordName,
        // AddContact needs the office context, which this tab already holds
        officeID: this.myOfficeID,
        officeIDList: this.OfficeIDList,
        coreData:this.coreDetail
      },
    });

    dialogRef.afterClosed().subscribe((result: WelcomeEmailResult) => {
      if (!result) {
        return; // cancelled, or the send failed and the user backed out
      }

      // The dialog performs the send itself (AIAutomation/
      // SendCoreEducationalMaterialToContacts) and only closes on success, so
      // there is nothing to post here -- just confirm and refresh.
      const total = result.people.length;
      this.toastr.success(
        'Sent to ' + total + ' recipient' + (total === 1 ? '' : 's') + '.',
        '', { timeOut: 3000 });

      this.getActivityEMails3C();
    });
  }

  addEmailAction() {
    const dialogRef = this.dialog.open(AddEmailActionComponent, {     
      data: {
        moduleName:this.mainModulename,      
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
       this.getActivityEMails3C();
      }      
    });
  } 

   // get Activity List
   getActivityEMails3C() {
    var cType=0;
    if(this.mainModulename=="Core"){
      cType=1;
    }
    if(this.mainModulename=="Contact"){
      cType=2;
    }
    if(this.mainModulename=="Company"){
      cType=3;
    }
    var ReqModel={
      cid:Number(sessionStorage.getItem('transactionID')),      
      cType:cType,
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseId:Number(this.databaseId)      
     }
     this.loaderService.show();
     this.taskService.getActivityEMails(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        this.loaderService.hide();
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
          this.getTagListResponseHolder = response.data.emails;                  
          this.All3CEmailList = this.getTagListResponseHolder;
          this.countChange.emit((this.All3CEmailList || []).length);
          if(this.All3CEmailList!=null){
            this.All3CEmailList.forEach(e => {
              if(e.isRead==true){
                e.senmessage="Opened";
              }
              if(e.isRead==false){
                if(e.isSent==true){
                  e.senmessage= "Sent";
                }else{
                  e.senmessage= "Failed";
                }
              }
              
            });
          }
        }
        else {
          this.All3CEmailList=[];
          this.countChange.emit(0);
          this.loaderService.hide();    
        }
      }else{
        this.All3CEmailList=[];
        this.countChange.emit(0);
        this.loaderService.hide();
      }
    });
  }

  removeActivityEmail(type: any) {  
    var message = `Are you sure you want to delete?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();
        var cType=0;
        if(this.mainModulename=="Core"){
          cType=1;
         }
        if(this.mainModulename=="Contact"){
          cType=2;
         }
        if(this.mainModulename=="Company"){
          cType=3;
         }
        var ReqModel = {
          mailIDs:[type.mailID],
          cid:Number(sessionStorage.getItem('transactionID')),      
          cType:cType,
          userID:this.currentUser.UID,
          organizationID:Number(this.organizationId),
          officeID: this.myOfficeID,
          databaseId:Number(this.databaseId)  
        }     
        this.taskService.removeActivityEmail(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {             
              this.toastr.success('Activity Email deleted successfully.', '', {
                timeOut: 3000,
              });
              this.getActivityEMails3C();
              this.loaderService.hide();
            }
          }
          else{
            this.loaderService.hide();
          }
        });
      }
    });
   }

   
   changeToggle(event: any) {
     if(event.checked==true){  
      this.title= "View Broadcasting";  
      this.showEmail=false;
      this.showBroadCast=true;
      this.get3CBroadcastMessage();
     }
     if(event.checked==false){
      this.title= "View Broadcasting";
      this.showEmail=true;
      this.showBroadCast=false;
      this.getActivityEMails3C();     
     }
   }

   get3CBroadcastMessage(){
    var cType=0;
    if(this.mainModulename=="Core"){
      cType=1;
    }
    if(this.mainModulename=="Contact"){
      cType=2;
    }
    if(this.mainModulename=="Company"){
      cType=3;
    }
    var ReqModel={
      cid:Number(sessionStorage.getItem('transactionID')),      
      cType:cType,
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseId:Number(this.databaseId)
     }
     this.loaderService.show();
     this.taskService.get3CBroadcastMessages(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        this.loaderService.hide();
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
          this.getTagListResponseHolder = response.data;                  
          this.All3CBroadCastList = this.getTagListResponseHolder;
          if(this.All3CBroadCastList.length>0){
            this.All3CBroadCastList.forEach(e => {
              if(e.isRead==true){
                e.senmessage="Opened";
              }
              if(e.isRead==false){
                if(e.isSent==true){
                  e.senmessage= "Sent";
                }else{
                  e.senmessage= "Failed";
                }
              }
              
            });
          }
        }
        else {
          this.All3CBroadCastList=[];
          this.loaderService.hide();    
        }
      }else{
        this.All3CBroadCastList=[];
        this.loaderService.hide();
      }
    });
   }
  
   
   resentBroadcastMessage(data:any) {  
    var message = `Are you sure you want to Resend?`;
    const title = `Confirm`;
    const confirm = `Resend`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();        
        var ReqModel={
          iD:data.id,            
          userID:this.currentUser.UID,
          organizationID:Number(this.organizationId),
          officeID: this.myOfficeID,
          databaseId:Number(this.databaseId)
         }
         this.loaderService.show();
         this.taskService.resentBroadcastMessage(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.getTagListResponseHolder = response;
            this.loaderService.hide();
            if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
              this.toastr.success('Resend successfully.', '', {
                timeOut: 3000,
              });
              this.get3CBroadcastMessage();
            }
            else {         
              this.loaderService.hide();    
            }
          }else{       
            this.loaderService.hide();
          }
        });
      }
    });
   }

   
}
